import type { FloorIdT, Npc } from '@/content/schema';
import type { Ctx } from '@/core/context';

/**
 * 巡場的人：駐廠人員（外部，超商派駐）、品保小葉（廠內巡檢，內部）、廠長……
 * 每個人依時間在幾個樓層之間輪巡；位置由 World 的巡邏 actor 每幀更新到這裡。
 */
export const watcherPos = new Map<string, { x: number; z: number; floor: FloorIdT }>();

export const patrollers = (ctx: Ctx): Npc[] => ctx.c.npcs.filter(n => n.patrol);

export function watcherFloor(ctx: Ctx, n: Npc): FloorIdT | null {
  const P = n.patrol!;
  if (P.visit) { const v = ctx.day.visits?.[n.id]; return v && v.floor && ctx.day.events.playSec < v.until ? v.floor as FloorIdT : null; }
  const slot = Math.floor((ctx.day.clock - ctx.day.shiftStart) / P.minutesPerFloor) + P.offset;
  return P.floors[((slot % P.floors.length) + P.floors.length) % P.floors.length];
}

/** 誰看到玩家了？回傳第一個在視野內的巡場 NPC */
export function whoSees(ctx: Ctx, x?: number, z?: number): Npc | null {
  const [px, pz] = x != null && z != null ? [x, z] : ctx.world.playerPos();
  const r = ctx.c.game.watchers.visionRadius;
  for (const n of patrollers(ctx)) {
    if (!n.patrol!.watches) continue;
    const w = watcherPos.get(n.id);
    if (!w || w.floor !== ctx.day.floor || watcherFloor(ctx, n) !== ctx.day.floor) continue;
    if (Math.hypot(w.x - px, w.z - pz) <= r) return n;
  }
  return null;
}

/** v1.1 來訪式巡場：每秒呼叫一次，決定誰什麼時候來玩家這一層巡 */
export function tickVisits(ctx: Ctx, rnd: () => number): void {
  const d = ctx.day; const now = d.events.playSec; d.visits ??= {};
  for (const n of patrollers(ctx)) {
    const V = n.patrol!.visit; if (!V) continue;
    const gap = () => (V.everyMin[0] + rnd() * (V.everyMin[1] - V.everyMin[0])) * 60;
    let s = d.visits[n.id];
    if (!s) {
      // 第一次：今天會不會來（廠長很少見）；會來的話排在之後的某個時間
      const comes = V.perDayChance == null || rnd() < V.perDayChance;
      s = d.visits[n.id] = { floor: null, until: 0, next: comes ? now + (V.perDayChance != null ? 120 + rnd() * 1500 : gap() * (0.3 + rnd() * 0.7)) : Infinity, count: 0 };
    }
    if (s.floor && now >= s.until) { s.floor = null; s.next = V.maxPerDay != null && s.count >= V.maxPerDay ? Infinity : now + gap(); }
    if (!s.floor && now >= s.next) {
      if (!n.patrol!.floors.includes(d.floor)) { s.next = now + 45; continue; }   // 玩家在他不巡的樓層：晚一點再看
      s.floor = d.floor; s.until = now + V.stayMin * 60; s.count++;
    }
  }
}
